  document.addEventListener('click', function (e) {
  // Desktop tab click handler
  const link = e.target.closest('.pdp-cro-tab-com-main-desktop [data-desktop-tab] a');
  if (!link) return; // If not a valid link, return

  e.preventDefault(); // Prevent default behavior for tab links

  const productTab = link.closest('.pdp-cro-tab-com-main-desktop');
  if (!productTab) return;

  const hrefId = link.getAttribute('href'); // Get the href from the tab link

  // Remove active class from all tabs and panels
  productTab.querySelectorAll('a').forEach((a) => a.classList.remove('active'));
  productTab.querySelectorAll('.tab-panal').forEach((panel) => panel.classList.remove('active'));

  // Add active class to the clicked tab and show the corresponding panel
  link.classList.add('active');

  const targetPanel = document.querySelector(hrefId);
  if (targetPanel) targetPanel.classList.add('active');
});


document.addEventListener('click', function (e) {
  // Mobile tab click handler
  const link = e.target.closest('.pdp-cro-tab-com-main-mobile [data-mobile-tab]  a');
  if (!link) return; // If not a valid link, return

  e.preventDefault(); // Prevent default behavior for tab links

  const productTab = link.closest('.pdp-cro-tab-com-main-mobile');
  if (!productTab) return;

  const hrefId = link.getAttribute('href'); // Get the href from the tab link

  // Remove active class from all tabs and panels
  productTab.querySelectorAll('a').forEach((a) => a.classList.remove('active'));
  productTab.querySelectorAll('.tab-panal').forEach((panel) => panel.classList.remove('active'));

  // Add active class to the clicked tab and show the corresponding panel
  link.classList.add('active');

  const targetPanel = document.querySelector(hrefId);
  if (targetPanel) targetPanel.classList.add('active');
});

document.addEventListener('DOMContentLoaded', function () {

  const addBtns = document.querySelectorAll('[data-add-btn]');

  if (!addBtns.length) return;

  addBtns.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const mainAtc = document.querySelector('.product-form__buttons .product-form__submit');

      if (!mainAtc) return;

      // Scroll to main ATC
      mainAtc.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Wait for scroll to finish, then click
      setTimeout(() => {
        mainAtc.click();
      }, 600); // adjust if needed
    });
  });

});